
import { cloneDeep } from 'lodash';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { aclModule } from '@/store/acl';
import { dataAssetsModule } from '@/store/application/data.assets.module';
import { PageState, PageTypes } from '@/store/application/page.definitions';
import { NModalWindow, NButton } from '@/uikit';
import NButtonGroup from '@/uikit/buttons/NButtonGroup.vue';
import NForm, { IFormLayout } from '@/uikit/forms/NForm.vue';

@Options({
  name: 'FiltersBig',
  components: {
    NButton,
    NButtonGroup,
    NForm,
    NModalWindow
  },
  emits: ['resetFields', 'close', 'update:modelValue', 'update:enabled-fields', 'report']
})
export default class FiltersBig extends Vue {
  @Prop({ type: Array, required: true })
  formLayout!: IFormLayout;

  @Prop({ type: [Object, Array], required: true })
  readonly modelValue!: any;

  @Prop({ type: String, required: false })
  readonly dataQa?: string;

  @Prop({ type: String, required: false })
  readonly itemKey?: string;

  @Prop({ type: String, required: false })
  readonly headerText?: string;

  @Prop({ type: [Object, Array], default: () => ({}) })
  readonly state?: PageState;

  @Prop({ type: Boolean, default: false })
  readonly hasReport!: boolean;

  @Prop({ type: [Array] })
  readonly enabledFields?: string[];

  model: any = {};

  get isEvents(): boolean {
    return this.state?.pageType === PageTypes.Events;
  }

  get isEpisodes(): boolean {
    return this.state?.pageType === PageTypes.Episodes;
  }

  get isCards(): boolean {
    return this.state?.pageType === PageTypes.Cards;
  }

  get isClusters(): boolean {
    return this.state?.pageType === PageTypes.Clusters;
  }

  get isAuditLogs(): boolean {
    return this.state?.pageType === PageTypes.AuditLogs;
  }

  get isSwitchVisible(): boolean {
    const isSearchPage = this.$route.name === 'SearchPage';
    return !isSearchPage;
  }

  get canCreateReport() {
    const canAddReport = aclModule.getAccess('ffsecurity.add_report');
    return this.hasReport && canAddReport;
  }

  get dataAssetsModule() {
    return dataAssetsModule;
  }

  submitAndClose() {
    this.submit() && this.closeFilter(true);
  }

  submit() {
    if (this.$refs.form.validate()) {
      this.$emit('update:modelValue', this.model);
      return true;
    } else {
      this.$refs.form.displayErrors();
      return false;
    }
  }

  resetFilters() {
    this.model = {};
    this.$emit('resetFilters');
    this.closeFilter(true);
  }

  closeFilter(value: any) {
    this.$emit('close', value);
  }

  submitAndShowReportDialog() {
    if (this.submit()) {
      this.$emit('report');
      this.closeFilter(true);
    }
  }

  @Watch('modelValue', { deep: true })
  syncModelValue() {
    this.model = cloneDeep(this.modelValue);
  }

  async created() {
    this.syncModelValue();
  }
}
